import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Alarm Systems images
import intrusionAlarmsImage from '../assets/images/services/it/INTRUSTION ALARMS.jpg';

// Import IT Security video (can be reused for Alarm Systems)
import itVideo from '../assets/videos/services/IT_Security.mp4';

// Import benefits image
import alarmBenefitsImage from '../assets/images/services/it/INTRUSTION ALARMS.jpg';

const AlarmSystemsPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Alarm Systems" description="Intrusion alarm and detection systems in DRC. Protect your property with professional alarm solutions by Cool & Care." keywords="alarm systems DRC, intrusion detection, security alarms Kinshasa, burglar alarms" />
      <ServiceSchema name="Alarm Systems" description="Intrusion alarm and detection systems for property protection." url="/alarm-systems" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'Alarm Systems', url: '/alarm-systems' }]} />
      <ServicePage
        serviceName={t('servicePage.services.alarmSystems.name')}
      serviceDescription={t('servicePage.services.alarmSystems.description')}
      videoUrl={itVideo}
      productImages={[
        intrusionAlarmsImage
      ]}
      features={t('servicePage.services.alarmSystems.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.alarmSystems.benefits', { returnObjects: true }) as string[]}
      benefitsImage={alarmBenefitsImage}
    />
    </>
  );
};

export default AlarmSystemsPage;
